import React from 'react';
import { useSentMeetings } from '../../../../../../data/hooks/meeting/useSentMeetings';
import CommonTabContent from '../CommonTabContent';

function SentMeetings(props) {
    const { eventId } = props,
        meetings = useSentMeetings(eventId);

    return <CommonTabContent eventId={eventId} meetings={meetings} />;
}

export default SentMeetings;
